import styled from 'styled-components';

const ChatStepContainer = styled.div`
  background: #fff;
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 1px 2px 0px;
  display: flex;
  justify-content: center;
  margin: 0 6px 10px 6px;
  padding: 16px;
`;

export default ChatStepContainer;
